import { UnmappedPlansBanner } from "../UnmappedPlansBanner";

export const UnmappedPlansBannerSection = ({
  carrierNames,
}: {
  carrierNames: string[];
}): React.JSX.Element | null =>
  carrierNames.length > 0 ? (
    <UnmappedPlansBanner carrierNames={carrierNames} />
  ) : null;
